const NEWS_IMAGE_BASE = "https://www.aavisa.com/";

function resolveNewsImageUrl(path) {
  if (typeof path !== "string" || path.trim() === "") {
    return "";
  }

  const normalizedPath = path.trim();
  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  return NEWS_IMAGE_BASE + normalizedPath.replace(/^\/+/, "");
}

module.exports = {
  resolveNewsImageUrl
};



// WEBPACK FOOTER //
// ./src/newsImage.js